var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.32802 5.99202H0.75V17.0219H4.32802V5.99202Z",
    fill: "#F1F8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0739 6.12137C14.0359 6.10947 13.9999 6.09646 13.9601 6.08523C13.9119 6.07427 13.864 6.06511 13.815 6.0573C13.6251 6.01911 13.4168 5.99205 13.173 5.99205C11.0871 5.99205 9.76385 7.51331 9.32811 8.10079V5.99202H5.75006V17.0219H9.32808V11.0056C9.32808 11.0056 12.0319 7.22939 13.1729 10.0028V17.0219H16.75V9.57879C16.75 7.91216 15.6109 6.52345 14.0739 6.12137Z",
    fill: "#F1F8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2501 2.73323C4.2501 3.7025 3.46644 4.488 2.50008 4.488C1.53366 4.488 0.750034 3.70247 0.750034 2.73323C0.750034 1.76415 1.53366 0.978516 2.50008 0.978516C3.46644 0.978516 4.2501 1.76415 4.2501 2.73323Z",
    fill: "#F1F8FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInIcon);
export default __webpack_public_path__ + "static/media/inIcon.f238df9a6557cd972317ec01891b058a.svg";
export { ForwardRef as ReactComponent };